import { c as _c } from "react/compiler-runtime";
import type { AdItem, Shop, ShopGoogleReviews, UserProfileInfo } from '@sbt-web/network/types';
import { DEFAULT_ADVERTISER_NAME } from '@/shared/constants';
import { AdDetailCompanyPro } from '../AdDetailCompanyPro';
export interface AdvertiserInfoProProps {
  item: AdItem;
  shop: Shop | null;
  shopGoogleReviews: ShopGoogleReviews | null;
  advertiserProfile: UserProfileInfo | null;
}
export const AdvertiserInfoPro = t0 => {
  const $ = _c(15);
  const {
    shop,
    shopGoogleReviews,
    item,
    advertiserProfile
  } = t0;
  if (shop) {
    const {
      name,
      logo,
      adsCount,
      address,
      urls,
      website,
      social,
      shopId,
      openingTime
    } = shop;
    const t1 = urls?.default;
    const t2 = logo?.medium?.secureuri;
    let t3;
    if ($[0] !== address || $[1] !== adsCount || $[2] !== item || $[3] !== name || $[4] !== openingTime || $[5] !== shopGoogleReviews || $[6] !== shopId || $[7] !== social || $[8] !== t1 || $[9] !== t2 || $[10] !== website) {
      t3 = <AdDetailCompanyPro name={name} adsCount={adsCount} address={address} openingTime={openingTime} shopId={shopId} website={website} social={social} url={t1} logo={t2} item={item} shopGoogleReviews={shopGoogleReviews} />;
      $[0] = address;
      $[1] = adsCount;
      $[2] = item;
      $[3] = name;
      $[4] = openingTime;
      $[5] = shopGoogleReviews;
      $[6] = shopId;
      $[7] = social;
      $[8] = t1;
      $[9] = t2;
      $[10] = website;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t1 = advertiserProfile?.username ?? DEFAULT_ADVERTISER_NAME;
  let t2;
  if ($[12] !== item || $[13] !== t1) {
    t2 = <AdDetailCompanyPro name={t1} item={item} />;
    $[12] = item;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};